import { memo } from "react";
import WithDriverIconPopup from "./WithDriverIconPopup";

function ReturnToTerminalMarker({color}) {
  const backgroundColor = color || "#01917E";
  return (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "scale(2.0)" }}
    >
      <g opacity="0.68" filter="url(#filter0_d)">
        <path
          d="M14.0875 6.24336L20.2566 12.4125C20.5811 12.737 20.5811 13.263 20.2566 13.5875L14.0875 19.7566C13.763 20.0811 13.237 20.0811 12.9125 19.7566L6.74336 13.5875C6.41888 13.263 6.41888 12.737 6.74336 12.4125L12.9125 6.24336C13.237 5.91888 13.763 5.91888 14.0875 6.24336Z"
          fill="white"
        />
        <path
          d="M14.7946 5.53626L20.9637 11.7054C21.6788 12.4204 21.6788 13.5796 20.9637 14.2946L14.7946 20.4637C14.0796 21.1788 12.9204 21.1788 12.2054 20.4637L6.03626 14.2946C5.32125 13.5796 5.32125 12.4204 6.03626 11.7054M14.7946 5.53626L6.03626 11.7054M14.7946 5.53626C14.0796 4.82125 12.9204 4.82125 12.2054 5.53626L6.03626 11.7054M14.7946 5.53626L6.03626 11.7054"
          stroke={backgroundColor}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8473 12.3969H14.476V16.5064C14.476 16.779 14.2551 17 13.9825 17H12.9696C12.6966 17 12.4752 16.7786 12.4752 16.5056V12.3969H11.1039C10.7079 12.3969 10.5 12.0373 10.5 11.7155C10.5 11.3672 10.7729 11 11.1039 11H15.7857C16.2861 11 16.5 11.3801 16.5 11.7155C16.5 12.0509 16.2682 12.3969 15.8473 12.3969Z"
        fill={backgroundColor}
      />
      <defs>
        <filter
          id="filter0_d"
          x="0.5"
          y="0"
          width="26"
          height="26"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default WithDriverIconPopup(memo(ReturnToTerminalMarker));
